import { createFileRoute, useRouter } from '@tanstack/react-router'
import { withSessionRedirect } from '../lib/require-session.ts'
import { VaultDaemons } from '../components/VaultDaemons.tsx'
import { fetchHierarchy } from '../lib/hierarchy-api.ts'
import { getTenantKey, listDaemons } from '../lib/vault-api.ts'
import { useIsUnlocked } from '../lib/vault-unlock.ts'
import { useAutoRefresh } from '../lib/use-auto-refresh.ts'

export const Route = createFileRoute('/vault/daemons')({
  loader: async () =>
    withSessionRedirect(async () => {
      const tree = await fetchHierarchy()
      const rootId = tree.roots[0]?.id ?? ''
      if (!rootId) return { rootId, rows: [], currentKekVersion: 0 }
      const [rows, tenantKey] = await Promise.all([
        listDaemons(rootId),
        getTenantKey(rootId),
      ])
      return {
        rootId,
        rows,
        currentKekVersion: tenantKey.currentKekVersion ?? 0,
      }
    }),
  component: VaultDaemonsRoute,
})

/** Enrolment status changes only on daemon heartbeats and admin actions —
 * slower than the approvals queue is enough, per Task 38's spec. */
const REFRESH_MS = 15_000

function VaultDaemonsRoute() {
  const { rootId, rows, currentKekVersion } = Route.useLoaderData()
  const router = useRouter()
  useAutoRefresh(REFRESH_MS)
  const unlocked = useIsUnlocked()

  return (
    <VaultDaemons
      rootId={rootId}
      rows={rows}
      currentKekVersion={currentKekVersion}
      unlocked={unlocked}
      onChanged={async () => {
        await router.invalidate()
      }}
    />
  )
}
